<template>
  <div class="main mainIndicateur0">
      <div class="ind2-section sectionCI0">
        <h2 class="h2Ind2">Avez-vous des douleurs</h2>
          <div class="bloc-douleur1">
            <h4>Au travail :</h4>
            <ul class="douleur1">
              <li>
                <button  :class="[{selected: douleur.travail === true}, 'oui']" @click.prevent="analyseResult(true)">
                  <p>oui</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.travail === false}, 'non']" @click.prevent="analyseResult(false)">
                  <p>non</p>
                </button>
              </li>
            </ul>
          </div>
          <div class="bloc-douleur2">
            <h4>En dehors du travail :</h4>
              <ul class="douleur2">
                <li>
                  <button  :class="[{selected: douleur.maison === true}, 'oui']" @click.prevent="analyseResult(null, true)">
                    <p>oui</p>
                  </button>
                </li>
                <li>
                  <button :class="[{selected: douleur.maison === false}, 'non']" @click.prevent="analyseResult(null, false)">
                    <p>non</p>
                  </button>
                </li>
              </ul>
          </div>
      </div>
    </div>
</template>


<script>
//définir une fonction qui va me permettre de ne pas me faire passer par lenght afin d'obtenir la longueur de mmon tableau d'objects
//define a function which will allow me not to pass by lenght in order to obtain the length of mmon array of objects
Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};
export default {
  name: "Indicateur_1",
  props: {
    max: {
      type: [Number],
      default: 10
      },    
    min: {
      type: [Number],
      default: 0
      },
  },

  data() {
    return {
      user: JSON.parse(localStorage.user)|| [],
      douleur: {
        travail: null,
        maison: null,
      },
    };
  },
  created(){
    if (typeof(localStorage.user) !== undefined){
      this.user = JSON.parse(localStorage.user);
      this.indicateur = this.user.cI;
      }
    localStorage.indicateur1 = JSON.stringify(null);
  },
  methods: {
    analyseResult(travail=null, maison=null){
      if (travail !== null){
        this.douleur.travail = travail;
        console.log(localStorage.indicateur1);
        if (typeof localStorage.indicateur1 !== undefined && typeof localStorage.indicateur1.maison !== undefined && JSON.parse(localStorage.indicateur1) !== null){
          localStorage.indicateur1 = JSON.stringify({'travail': this.douleur.travail, 'maison': JSON.parse(localStorage.indicateur1).maison});
        }else{
          localStorage.indicateur1 = JSON.stringify({'travail': this.douleur.travail});
        }
        
        
      }else if (maison !== null){
        this.douleur.maison = maison;
        if (typeof(localStorage.indicateur1) !== undefined && typeof localStorage.indicateur1.travail !== undefined && JSON.parse(localStorage.indicateur1) !== null){
          localStorage.indicateur1 = JSON.stringify({'travail': JSON.parse(localStorage.indicateur1).travail, 'maison': this.douleur.maison});
        }else{
        localStorage.indicateur1 = JSON.stringify({'maison':  this.douleur.maison});
        }
        
      }
      console.log(localStorage.indicateur1);
    }
  },

};
</script>

<style>
.fakeRange{
  width: 95%;
  height: 30px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0;
  margin: 0;
  border-radius: 15px;
}
.fakeOption{
  width: 10%;
  height: 100%;
  background-color: white;
  border: 2px solid grey;
  border-right: none;
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 1.5s, color 1.5s ease-out;
}
.first{
  border-radius: 15px 0px 0px 15px;
}
.last{
  border-right: 2px solid grey;
  border-radius: 0px 15px 15px 0px;
}
.passed{
  background-color: #54c7da;
  color: white;
}
.active{
  background-color: #54c7da;
  color: white;
}
.mainIndicateur0{
  background-color: rgba(255, 255, 255, 0.7);
   border-radius: 8px 8px 8px 8px;
   padding-bottom: 20px;
   top: 10px;
   height: 45vh;
}
.sectionCI0{
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.mainIndicateur1 h4, .mainIndicateur34 h4{
  color: #c41316;
}
</style>


// WEBPACK FOOTER //
// src/components/indicateur/Indicateur_1.vue